import React from 'react';
import drinkBg from '../../assets/images/drinks/drink-bg.png';
import drink1 from '../../assets/images/drinks/drink-1.png';
import drink2 from '../../assets/images/drinks/drink-2.png';
import drink3 from '../../assets/images/drinks/drink-3.png';
import drink4 from '../../assets/images/drinks/drink-4.png';

const ORDER_LINK = 'https://grill-me-crazy-indo-mexican-alice-springs.nextorder.com/';

const drinks = [
  {
    name: 'Classic Margarita',
    description:
      'Olmeca Altos Blanco, Cointreau, fresh lime, and sour mix. The standard that never fails.',
    image: drink1,
  },
  {
    name: 'Nimbu Masala Mojito',
    description:
      'Fresh lemon, mint, soda, and a signature Indian masala blend. Refreshingly zesty with a spicy twist.',
    image: drink2,
  },
  {
    name: 'Chai Spice Whiskey Sour',
    description:
      'Award-winning Indian whisky, chai spices, citrus, and velvety foam. Warm, smooth, and perfectly balanced.',
    image: drink3,
  },
  {
    name: 'Bombay Sunset',
    description:
      'Don Julio Blanco, Cointreau, mango purée, fresh lime, chilli-tajin, and chaat masala. Tropical with a bold Bombay kick.',
    image: drink4,
  },
];

const DrinksSection: React.FC = () => {
  return (
    <section id="drinks" className="w-full relative" style={{ backgroundColor: '#151515' }}>
      <div
        className="relative w-full"
        style={{
          maxWidth: '1920px',
          margin: '0 auto',
        }}
      >
        {/* Background Image */}
        <img
          src={drinkBg}
          alt="Drinks Background"
          className="absolute inset-0 w-full h-full object-cover"
          style={{ display: 'block' }}
        />

        {/* Content Overlay */}
        <div
          className="relative z-10 flex flex-col lg:flex-row"
          style={{
            padding: 'clamp(30px, 5vw, 80px) clamp(20px, 5vw, 100px)',
            boxSizing: 'border-box',
          }}
        >
          <style>{`
            .drink-card {
              cursor: pointer;
              transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
              border: 2px solid transparent;
            }
            .drink-card:hover {
              transform: translateY(-8px);
              box-shadow: 0 12px 30px rgba(236, 70, 28, 0.3);
              border-color: #EC461C;
            }
            .drink-card img {
              transition: transform 0.4s ease, filter 0.4s ease;
            }
            .drink-card:hover img {
              transform: scale(1.1) rotate(-3deg);
              filter: brightness(1.2) drop-shadow(0 4px 12px rgba(236, 70, 28, 0.4));
            }
            .drinks-grid {
              display: grid;
              grid-template-columns: repeat(1, 1fr);
              gap: 16px;
            }
            @media (min-width: 640px) {
              .drinks-grid {
                grid-template-columns: repeat(2, 1fr);
                gap: 20px;
              }
            }
            @media (min-width: 1024px) {
              .drinks-grid {
                grid-template-columns: repeat(2, 1fr);
                gap: 24px;
              }
            }
          `}</style>

          {/* Left Side */}
          <div
            className="flex flex-col justify-center w-full lg:w-1/2"
            style={{ paddingRight: 'clamp(0px, 3vw, 60px)', marginBottom: 'clamp(30px, 5vw, 0px)' }}
          >
            {/* Label */}
            <div
              className="flex items-center justify-center mb-6"
              style={{
                width: 'clamp(220px, 25vw, 341px)',
                height: '34px',
                backgroundColor: '#FFC600',
                borderRadius: '50px',
              }}
            >
              <span
                className="font-teko text-center block leading-none"
                style={{ fontSize: 'clamp(16px, 2vw, 25px)', color: '#151515', fontWeight: 400 }}
              >
                Daily, Until The Fun Ends
              </span>
            </div>

            {/* Heading */}
            <div className="text-left">
              <h2
                className="font-teko font-regular leading-none mb-0"
                style={{ fontSize: 'clamp(50px, 8vw, 98px)', color: '#FFFFFF' }}
              >
                HAPPINESS
              </h2>
              <h2
                className="font-teko font-regular leading-none mb-0"
                style={{ fontSize: 'clamp(50px, 8vw, 98px)', color: '#FFFFFF' }}
              >
                SERVED
              </h2>
              <h2
                className="font-teko font-regular leading-none"
                style={{ fontSize: 'clamp(50px, 8vw, 98px)', color: '#FFC600' }}
              >
                BY THE GLASS
              </h2>
            </div>

            {/* Parallelograms with time */}
            <div className="flex items-center mt-6 md:mt-8" style={{ gap: 'clamp(10px, 2vw, 20px)' }}>
              {/* 3 PM Parallelogram */}
              <div
                className="flex items-center justify-center"
                style={{
                  width: 'clamp(60px, 6vw, 80px)',
                  height: 'clamp(45px, 5vw, 60px)',
                  backgroundColor: '#EC461C',
                  transform: 'skewX(-12deg)',
                  borderRadius: '4px',
                }}
              >
                <span
                  className="font-teko text-center block leading-none"
                  style={{
                    fontSize: 'clamp(20px, 2.5vw, 28px)',
                    color: '#FFFFFF',
                    fontWeight: 400,
                    transform: 'skewX(12deg)',
                  }}
                >
                  3 PM
                </span>
              </div>

              {/* Dash */}
              <div
                style={{
                  width: 'clamp(14px, 2vw, 20px)',
                  height: '2px',
                  backgroundColor: '#FFFFFF',
                  opacity: 0.5,
                }}
              />

              {/* 6 PM Parallelogram */}
              <div
                className="flex items-center justify-center"
                style={{
                  width: 'clamp(60px, 6vw, 80px)',
                  height: 'clamp(45px, 5vw, 60px)',
                  backgroundColor: '#EC461C',
                  transform: 'skewX(-12deg)',
                  borderRadius: '4px',
                }}
              >
                <span
                  className="font-teko text-center block leading-none"
                  style={{
                    fontSize: 'clamp(20px, 2.5vw, 28px)',
                    color: '#FFFFFF',
                    fontWeight: 400,
                    transform: 'skewX(12deg)',
                  }}
                >
                  6 PM
                </span>
              </div>
            </div>

            {/* Paragraph */}
            <p
              className="mt-6 md:mt-8"
              style={{
                fontSize: 'clamp(16px, 2.2vw, 25px)',
                color: '#FFFFFF',
                fontFamily: "'Inter', sans-serif",
                fontWeight: 400,
                lineHeight: '1.5',
                maxWidth: '600px',
              }}
            >
              Your after-work excuse. Handcrafted cocktails, craft beers and classic margaritas at
              prices that make you stay for one more.
            </p>

            {/* Button */}
            <div className="mt-6 md:mt-8">
              <div
                style={{
                  boxShadow: '0 4px 0 0 #151515',
                  borderRadius: '8px',
                  display: 'inline-block',
                }}
              >
                <a
                  href={ORDER_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-teko font-normal text-black block transition-all duration-200 hover:translate-y-[4px] hover:bg-yellow-400"
                  style={{
                    backgroundColor: '#FFC600',
                    padding: '15px 20px',
                    fontSize: 'clamp(14px, 1.5vw, 18px)',
                    height: '47px',
                    display: 'flex',
                    alignItems: 'center',
                    border: '1px solid #151515',
                    cursor: 'pointer',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    whiteSpace: 'nowrap',
                  }}
                >
                  CLAIM YOUR HAPPY HOURS
                </a>
              </div>
            </div>
          </div>

          {/* Right Side - Drink Cards */}
          <div
            className="flex items-center w-full lg:w-1/2"
          >
            <div className="drinks-grid w-full">
              {drinks.map((drink, index) => (
                <div
                  key={index}
                  className="flex flex-col drink-card"
                  style={{
                    backgroundColor: '#000000',
                    padding: 'clamp(16px, 2vw, 24px)',
                    boxSizing: 'border-box',
                  }}
                >
                  {/* Drink Image */}
                  <img
                    src={drink.image}
                    alt={drink.name}
                    style={{
                      width: 'clamp(60px, 7vw, 84px)',
                      height: 'clamp(96px, 11vw, 134px)',
                      objectFit: 'contain',
                      marginBottom: 'clamp(10px, 1.5vw, 16px)',
                    }}
                  />

                  {/* Drink Name */}
                  <h3
                    className="font-teko uppercase"
                    style={{
                      fontSize: 'clamp(28px, 4vw, 48px)',
                      color: '#EC461C',
                      fontWeight: 500,
                      lineHeight: '1',
                      marginBottom: '8px',
                      wordWrap: 'break-word',
                      overflowWrap: 'break-word',
                    }}
                  >
                    {drink.name}
                  </h3>

                  {/* Description */}
                  <p
                    style={{
                      fontSize: 'clamp(11px, 1.2vw, 12px)',
                      color: '#7D7D7D',
                      fontFamily: "'Inter', sans-serif",
                      fontWeight: 400,
                      lineHeight: '1.5',
                    }}
                  >
                    {drink.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DrinksSection;
